import { ReactElement, useState, useEffect, useRef } from "react";
import apiServices from "../services/apiServices";
import defaultImage from "../../assets/images/default.png";

interface Props {
  file?: File
  id: number;
  alt?: string;
  style?: any;
  onImageLoaded?: (file: File | undefined) => void;
}

function SampleImage({ file, id, alt, style, onImageLoaded }: Props): ReactElement {
  const [imageUrl, setImageUrl] = useState<string>('');
  const imgRef = useRef<any>(null);

  useEffect(() => {
    if (id == null) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        if (file) {
          setImageUrl(URL.createObjectURL(file));
        } else {
          apiServices.getSampleImage(id).then((_file: File) => {
            setImageUrl(URL.createObjectURL(_file));
            if (onImageLoaded) {
              onImageLoaded(_file);
            }
          }).catch(e => {
            // pass
          })
        }
        observer.disconnect();
      }
    });

    observer.observe(imgRef.current);

    return () => observer.disconnect();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <img src={imageUrl ?? defaultImage} alt={alt} style={style} ref={imgRef} />
  );
};

export default SampleImage;
